module.exports = {
	"data": {
		"markdownRemark": {
			"html": "<blockquote>\n<p><strong>Note</strong>: The final project for this tutorial can be found on <a href=\"https://github.com/howtographql/graphql-js\">GitHub</a>. You can always use it as a reference whenever you get lost throughout the course of the following chapters.\nAlso note that each code block is annotated with a filename. These annotations directly link to the corresponding file on GitHub so you can clearly see where to put the code and what the end result will look like.</p>\n</blockquote>\n<h3>Overview</h3>\n<p>GraphQL is the rising star of backend technologies. It replaces REST as an API design paradigm and is becoming the new standard for exposing the data and functionality of a server.</p>\n<p>In this tutorial, you’ll learn how to build an <em>idiomatic</em> GraphQL server entirely from scratch. You are going to use the following technologies:</p>\n<ul>\n<li><a href=\"https://github.com/prisma/graphql-yoga\"><code>graphql-yoga</code></a>: Fully-featured GraphQL server with focus on easy setup, performance &#x26; great developer experience. It is built on top of <a href=\"https://expressjs.com/\">Express</a>, <a href=\"https://github.com/apollographql/apollo-server\"><code>apollo-server</code></a>, <a href=\"https://github.com/graphql/graphql-js\"><code>graphql-js</code></a> and more.</li>\n<li><a href=\"https://www.prisma.io/\">Prisma</a>: Prisma replaces traditional ORMs. Use the Prisma client to implement your GraphQL resolvers and simplify database access </li>\n<li>\n<p><a href=\"https://github.com/prisma/graphql-playground\">GraphQL Playground</a>: “GraphQL IDE” that allows to interactively explore the functionality of a GraphQL API by sending queries and mutations to it. It’s somewhat similar to <a href=\"https://www.getpostman.com/\">Postman</a> which offers comparable functionality for REST APIs. Among other things, a GraphQL Playground…</p>\n<ul>\n<li>… auto-generates a comprehensive documentation for all available API operations.</li>\n<li>… provides an editor where you can write queries, mutations &#x26; subscriptions, with auto-completion(!) and syntax highlighting.</li>\n<li>… lets you easily share your API operations.</li>\n</ul>\n</li>\n</ul>\n<h3>What to expect</h3>\n<p>The goal of this tutorial is to build an API for a <a href=\"https://news.ycombinator.com/\">Hacker News</a> clone. Here is a quick rundown of what to expect in this tutorial.</p>\n<p>You’ll start by learning the basics of how a GraphQL server works, simply by defining a <a href=\"https://www.prisma.io/blog/graphql-server-basics-the-schema-ac5e2950214e\"><em>GraphQL schema</em></a> for the server and writing corresponding <em>resolver functions</em>. In the beginning, these resolvers will only work with data that’s stored in-memory - so nothing will be persisted beyond the runtime of the server.</p>\n<p>Because nobody wants a server that’s not able to store and persist data, you’re going to add a database layer to it. The database layer is powered by <a href=\"https://www.prisma.io/\">Prisma</a> and will be connected to your GraphQL server via the <a href=\"https://www.prisma.io/docs/prisma-client\">Prisma client</a>. </p>\n<p>Once you have the database connected, you are going to add more advanced features to the API.</p>\n<p>You’ll start by implementing signup/login functionality that enables users to authenticate against the API. This will also allow you to check the permissions of your users for certain API operations.</p>\n<p>The next part of the tutorial is about adding realtime functionality to your API using GraphQL subscriptions.</p>\n<p>Lastly, you’ll allow the consumers of the API to constrain the list of items they retrieve from the API by adding filtering and pagination capabalities to it.</p>\n<p>Let’s get started 🚀</p>",
			"fields": {
				"slug": "/graphql-js/0-introduction/"
			},
			"excerpt": "Note : The final project for this tutorial can be found on  GitHub . You can always use it as a reference whenever you get lost throughout...",
			"frontmatter": {
				"title": "Introduction",
				"videoId": null,
				"videoAuthor": null,
				"parent": "/opt/build/repo/content/backend/graphql-js/0-introduction.md absPath of file",
				"question": "What is a GraphQL Playground?",
				"answers": [
					"A GraphQL IDE to work with a GraphQL API",
					"A tool to generate GraphQL operations",
					"A REST client",
					"The successor of Postman"
				],
				"correctAnswer": 0,
				"description": "Learn how to build a GraphQL server with graphql-yoga, Node.js & Prisma and best practices for authentication, filtering, pagination and subscriptions.",
				"pageTitle": "Building a GraphQL Server with Node.js & Prisma Tutorial"
			}
		},
		"mds": {
			"edges": [
				{
					"node": {
						"frontmatter": {
							"title": "Get started with your favorite technology",
							"description": null
						},
						"fields": {
							"slug": "/choose/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "adding users",
							"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
						},
						"fields": {
							"slug": "/wekan/1-adding-users/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "adding new Snap settings to code",
							"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
						},
						"fields": {
							"slug": "/wekan/0-adding-new-Snap-settings-to-code/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "aws",
							"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
						},
						"fields": {
							"slug": "/wekan/4-aws/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "apache",
							"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
						},
						"fields": {
							"slug": "/wekan/2-apache/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "custom css themes",
							"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
						},
						"fields": {
							"slug": "/wekan/10-custom-css-themes/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "It was great having you!",
							"description": null
						},
						"fields": {
							"slug": "/success/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "archive and delete",
							"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
						},
						"fields": {
							"slug": "/wekan/3-archive-and-delete/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "azure",
							"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
						},
						"fields": {
							"slug": "/wekan/5-azure/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "backup",
							"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
						},
						"fields": {
							"slug": "/wekan/6-backup/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "caddy webserver config",
							"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
						},
						"fields": {
							"slug": "/wekan/7-caddy-webserver-config/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "cloud foundry",
							"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
						},
						"fields": {
							"slug": "/wekan/8-cloud-foundry/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "cloudron",
							"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
						},
						"fields": {
							"slug": "/wekan/9-cloudron/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Introduction",
							"description": "Learn how to build a GraphQL server with Elixir & Absinthe and best practices for filters, authentication, pagination and subscriptions. Compatible with Apollo."
						},
						"fields": {
							"slug": "/graphql-elixir/0-introduction/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Getting Started",
							"description": "Learn how to setup a GraphQL server with Elixir & Absinthe as well as best practices for defining the GraphQL schema."
						},
						"fields": {
							"slug": "/graphql-elixir/1-getting-started/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Mutations",
							"description": "Learn best practices for implementing GraphQL mutations with Absinthe & Elixir. You can test your implementation in a GraphiQL Playground."
						},
						"fields": {
							"slug": "/graphql-elixir/3-mutations/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Summary",
							"description": "You learned how to build a GraphQL server with Elixir & Absinthe and best practices for filters, authentication, pagination and subscriptions."
						},
						"fields": {
							"slug": "/graphql-elixir/4-summary/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Queries",
							"description": "Learn how to define the GraphQL schema with Absinthe, implement query resolvers in Elixir and test your queries in a GraphiQL Playground."
						},
						"fields": {
							"slug": "/graphql-elixir/2-queries/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Introduction",
							"description": "Learn how to build a GraphQL server with graphql-yoga, Node.js & Prisma and best practices for authentication, filtering, pagination and subscriptions."
						},
						"fields": {
							"slug": "/graphql-js/0-introduction/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Getting Started",
							"description": "Learn how to setup a GraphQL server with Node.js & Express as well as best practices for defining the GraphQL schema."
						},
						"fields": {
							"slug": "/graphql-js/1-getting-started/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "A Simple Query",
							"description": "Learn how to define a GraphQL schema, implement query resolvers with Node.js and test your queries in a GraphQL Playground."
						},
						"fields": {
							"slug": "/graphql-js/2-a-simple-query/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Adding a Database",
							"description": "Learn how to add a database to your GraphQL server. The database is powered by Prisma and connected to the server via GraphQL bindings."
						},
						"fields": {
							"slug": "/graphql-js/4-adding-a-database/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "A Simple Mutation",
							"description": "Learn best practices for implementing GraphQL mutations with graphql-js, Node.js & Prisma. Test your implementation in a GraphQL Playground."
						},
						"fields": {
							"slug": "/graphql-js/3-a-simple-mutation/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Connecting Server and Database with the Prisma Client",
							"description": "Learn how to add a database to your GraphQL server. The database is powered by Prisma and connected to the server via GraphQL bindings."
						},
						"fields": {
							"slug": "/graphql-js/5-connecting-server-and-database/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Realtime GraphQL Subscriptions",
							"description": "Learn how to implement GraphQL subscriptions with Node.js, Express & Prisma to add realtime functionality to an app."
						},
						"fields": {
							"slug": "/graphql-js/7-subscriptions/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Authentication",
							"description": "Learn best practices for implementing authentication and authorization with Node.js, Express & Prisma."
						},
						"fields": {
							"slug": "/graphql-js/6-authentication/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Filtering, Pagination & Sorting",
							"description": "Learn how to add filtering and pagination capabilities to a GraphQL API with Node.js, Express & Prisma."
						},
						"fields": {
							"slug": "/graphql-js/8-filtering-pagination-and-sorting/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Summary",
							"description": "You learned how to build a GraphQL server with Node.js and best practices for filters, authentication, pagination and subscriptions."
						},
						"fields": {
							"slug": "/graphql-js/9-summary/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Introduction",
							"description": "Building a Server with GraphQL and Graphene"
						},
						"fields": {
							"slug": "/graphql-python/0-introduction/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Getting Started",
							"description": "Setting up a Django Graphene Project"
						},
						"fields": {
							"slug": "/graphql-python/1-getting-started/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Summary",
							"description": "Tutorial Summary"
						},
						"fields": {
							"slug": "/graphql-python/10-summary/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Mutations",
							"description": "Creating Data With Mutations"
						},
						"fields": {
							"slug": "/graphql-python/3-mutations/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Queries",
							"description": "Creating Your First Queries"
						},
						"fields": {
							"slug": "/graphql-python/2-queries/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Authentication",
							"description": "Authenticating on GraphQL"
						},
						"fields": {
							"slug": "/graphql-python/4-authentication/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Links and Voting",
							"description": "Enable Users to create Links and to Vote on them"
						},
						"fields": {
							"slug": "/graphql-python/5-links-and-voting/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Error Handling",
							"description": "Handling Errors on GraphQL"
						},
						"fields": {
							"slug": "/graphql-python/6-error-handling/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Filtering",
							"description": "Filtering GraphQL Queries"
						},
						"fields": {
							"slug": "/graphql-python/7-filtering/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Pagination",
							"description": "Simple Pagination with Graphene"
						},
						"fields": {
							"slug": "/graphql-python/8-pagination/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Relay",
							"description": "Using Relay on Graphene"
						},
						"fields": {
							"slug": "/graphql-python/9-relay/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Introduction",
							"description": "Learn how to build a GraphQL server with graphql-java and best practices for filters, authentication, pagination and subscriptions. Compatible with Apollo."
						},
						"fields": {
							"slug": "/graphql-java/0-introduction/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Getting Started",
							"description": "Learn how to setup a GraphQL server with graphql-java and best practices for defining the GraphQL schema in this tutorial."
						},
						"fields": {
							"slug": "/graphql-java/1-getting-started/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Pagination",
							"description": "Learn best practices for implementing limit-offset pagination in a GraphQL API using query arguments with a Node.js & Express GraphQL server."
						},
						"fields": {
							"slug": "/graphql-java/10-pagination/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Alternative approaches to schema development",
							"description": "Learn about an alternative approach to developing schemas with graphl-java with graphql-spqr"
						},
						"fields": {
							"slug": "/graphql-java/11-alternative-approaches/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Summary",
							"description": "You learned how to build a GraphQL server with graphql-java and best practices for filters, authentication, pagination and subscriptions."
						},
						"fields": {
							"slug": "/graphql-java/12-summary/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Queries",
							"description": "Learn how to define the GraphQL schema with graphql-java, implement query resolvers in Java and test your queries in a GraphiQL Playground."
						},
						"fields": {
							"slug": "/graphql-java/2-queries/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Mutations",
							"description": "Learn best practices for implementing GraphQL mutations with graphql-java & Java. You can test your implementation in a GraphiQL Playground."
						},
						"fields": {
							"slug": "/graphql-java/3-mutations/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Connectors",
							"description": "Learn how to write connectors in Java to load data from MongoDB with graphql-java and a Java GraphQL server."
						},
						"fields": {
							"slug": "/graphql-java/4-connectors/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Authentication",
							"description": "Learn best practices for implementing email-password authentication on a GraphQL Server written in Java."
						},
						"fields": {
							"slug": "/graphql-java/5-authentication/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "More Mutations",
							"description": "Learn best practices for implementing advanced GraphQL mutations with Java and graphql-java. You can test your implementation in a GraphiQL Playground."
						},
						"fields": {
							"slug": "/graphql-java/6-more-mutations/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Subscriptions",
							"description": "Learn how to implement server-side GraphQL subscriptions with Java to add realtime functionality to an app."
						},
						"fields": {
							"slug": "/graphql-java/8-subscriptions/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Error Handling",
							"description": "Learn best practices for validation of input arguments and implementing error handling in GraphQL with Java, Node.js & Express."
						},
						"fields": {
							"slug": "/graphql-java/7-error-handling/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Filtering",
							"description": "Learn best practices for implementing filters in a GraphQL API using query arguments with a Java GraphQL server."
						},
						"fields": {
							"slug": "/graphql-java/9-filtering/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Introduction",
							"description": "Learn how to build a GraphQL server with graphql-ruby and best practices for filters, authentication, pagination and subscriptions. Compatible with Apollo."
						},
						"fields": {
							"slug": "/graphql-ruby/0-introduction/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Getting Started",
							"description": "Learn how to setup a GraphQL server with graphql-ruby and best practices for defining the GraphQL schema."
						},
						"fields": {
							"slug": "/graphql-ruby/1-getting-started/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Queries",
							"description": "Learn how to define the GraphQL schema with graphql-ruby, implement query resolvers in Ruby and use a GraphiQL Playground to test your queries."
						},
						"fields": {
							"slug": "/graphql-ruby/2-queries/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Mutations",
							"description": "Learn best practices for implementing GraphQL mutations with Ruby and graphql-ruby. You can test your implementation in a GraphiQL Playground."
						},
						"fields": {
							"slug": "/graphql-ruby/3-mutations/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Authentication",
							"description": "Learn best practices for implementing email-password authentication on a GraphQL Server written in Ruby."
						},
						"fields": {
							"slug": "/graphql-ruby/4-authentication/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Connecting Nodes",
							"description": "Learn best practices for implementing advanced GraphQL mutations with Ruby and graphql-ruby. You can test your implementation in a GraphiQL Playground."
						},
						"fields": {
							"slug": "/graphql-ruby/5-connecting-nodes/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Error Handling",
							"description": "Learn best practices for validation of input arguments and implementing error handling in GraphQL with Ruby."
						},
						"fields": {
							"slug": "/graphql-ruby/6-error-handling/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Filtering",
							"description": "Learn best practices for implementing filters in a GraphQL API using query arguments with a Ruby GraphQL server."
						},
						"fields": {
							"slug": "/graphql-ruby/7-filtering/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Pagination",
							"description": "Learn best practices for implementing limit-offset pagination in a GraphQL API using query arguments with Ruby GraphQL server."
						},
						"fields": {
							"slug": "/graphql-ruby/8-pagination/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Introduction",
							"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
						},
						"fields": {
							"slug": "/graphql-scala/0-introduction/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Getting Started",
							"description": "In this chapter will be described how to setup the HTTP server, install all dependencies and setup the database."
						},
						"fields": {
							"slug": "/graphql-scala/1-getting-started/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Summary",
							"description": "You learned how to build a GraphQL server with graphql-ruby & Ruby and best practices for filters, authentication, pagination and subscriptions."
						},
						"fields": {
							"slug": "/graphql-ruby/9-summary/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "The first query",
							"description": "In this chapter you will learn last steps of preparation, add graphiql console for easy debugging and at the end, run your first query."
						},
						"fields": {
							"slug": "/graphql-scala/2-preparing-first-query/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Handling Arguments",
							"description": "In this chapter you will learn how to use arguments and how to handle them and pass to the business logic."
						},
						"fields": {
							"slug": "/graphql-scala/3-handling_arguments/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Custom Scalars",
							"description": "In this chapter Link model will get an additional field to store date and time. You will learn how to handle such custom types and use scalars."
						},
						"fields": {
							"slug": "/graphql-scala/5-custom_scalars/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Deferred Resolvers",
							"description": "In this chapter you will learn how to improve performance with deferred resolvers."
						},
						"fields": {
							"slug": "/graphql-scala/4-deferred_resolvers/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Interfaces",
							"description": "In this chapter we will introduce two additional models. We show the most common parts and extract those as an interface. This time you will work alone."
						},
						"fields": {
							"slug": "/graphql-scala/6-interfaces/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Relations",
							"description": "In this chapter you will learn how to connect models with relations. You will also learn how to prepare fetchers to use either relations or ids to get entities."
						},
						"fields": {
							"slug": "/graphql-scala/7-relations/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Mutations",
							"description": "In this chapter you will learn how to add data to the database."
						},
						"fields": {
							"slug": "/graphql-scala/8-mutations/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Authentication",
							"description": "Sangria's Middleware allows pre-processing queries. Gather all useful data in the following subqueries."
						},
						"fields": {
							"slug": "/graphql-scala/9-authentication/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "adding new Snap settings to code",
							"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
						},
						"fields": {
							"slug": "/wekan-wiki/0-adding-new-Snap-settings-to-code/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "adding users",
							"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
						},
						"fields": {
							"slug": "/wekan-wiki/1-adding-users/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "custom css themes",
							"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
						},
						"fields": {
							"slug": "/wekan-wiki/10-custom-css-themes/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "apache",
							"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
						},
						"fields": {
							"slug": "/wekan-wiki/2-apache/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "archive and delete",
							"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
						},
						"fields": {
							"slug": "/wekan-wiki/3-archive-and-delete/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "aws",
							"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
						},
						"fields": {
							"slug": "/wekan-wiki/4-aws/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "azure",
							"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
						},
						"fields": {
							"slug": "/wekan-wiki/5-azure/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "backup",
							"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
						},
						"fields": {
							"slug": "/wekan-wiki/6-backup/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "caddy webserver config",
							"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
						},
						"fields": {
							"slug": "/wekan-wiki/7-caddy-webserver-config/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "cloud foundry",
							"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
						},
						"fields": {
							"slug": "/wekan-wiki/8-cloud-foundry/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "cloudron",
							"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
						},
						"fields": {
							"slug": "/wekan-wiki/9-cloudron/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Introduction",
							"description": "Learn how to build a Hackernews clone with GraphQL, Angular & Apollo Client. You'll use angular-cli for the frontend and Graphcool for the backend."
						},
						"fields": {
							"slug": "/angular-apollo/0-introduction/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Getting Started",
							"description": "Start building a Hackernews clone. Create the frontend with angular-cli and the backend with Graphcool."
						},
						"fields": {
							"slug": "/angular-apollo/1-getting-started/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Deploying",
							"description": "Learn how to deploy an application built with Angular and Graphcool through Surge.sh."
						},
						"fields": {
							"slug": "/angular-apollo/10-deploying/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Queries: Loading link-items",
							"description": "Learn how you can use GraphQL queries with Apollo Client to load data from a server and display it in your Angular components."
						},
						"fields": {
							"slug": "/angular-apollo/2-queries-loading-links/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Summary",
							"description": "In this Fullstack GraphQL Tutorial with Angular & Apollo Client you learned how to build a production-ready Hackernews clone using angular-cli & Graphcool."
						},
						"fields": {
							"slug": "/angular-apollo/11-summary/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Mutations: Creating Links",
							"description": "Learn how you can use GraphQL mutations with Apollo Client. Use Apollo's service injected in the component to define and send mutations."
						},
						"fields": {
							"slug": "/angular-apollo/3-mutations-creating-links/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Routing",
							"description": "Learn how to use Angular Router  together with GraphQL and Apollo Client to implement navigation in an Angular app."
						},
						"fields": {
							"slug": "/angular-apollo/4-routing/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Authentication",
							"description": "Learn best practices to implement authentication with GraphQL & Apollo Client to provide an email-and-password-based login in an Angular app with Graphcool."
						},
						"fields": {
							"slug": "/angular-apollo/5-authentication/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "More Mutations and Updating the Store",
							"description": "Learn how to use Apollo's imperative store API to update the cache after a GraphQL mutation. The updates will automatically end up in your Angular components."
						},
						"fields": {
							"slug": "/angular-apollo/6-more-mutations-and-updating-the-store/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Filtering: Searching the List of Links",
							"description": "Learn how to use filters with GraphQL and Apollo Client. Graphcool provides a powerful filter and ordering API that you'll explore in this example."
						},
						"fields": {
							"slug": "/angular-apollo/7-filtering-searching-the-list-of-links/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Realtime Updates with GraphQL Subscriptions",
							"description": "Learn how to implement realtime functionality using GraphQL subscriptions with Apollo Client & Angular. The websockets will be handled by subscriptions-transport-ws."
						},
						"fields": {
							"slug": "/angular-apollo/8-subscriptions/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Introduction",
							"description": "Learn how to build a Hackernews clone with GraphQL, React & Apollo Client. Use create-react-app for the frontend and graphql-yoga & Prisma for the backend."
						},
						"fields": {
							"slug": "/react-apollo/0-introduction/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Pagination",
							"description": "Learn how to implement limit-offset pagination with GraphQL and Apollo Client in a Angular app. The Graphcool API exposes the required arguments for lists."
						},
						"fields": {
							"slug": "/angular-apollo/9-pagination/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Getting Started",
							"description": "Start building a Hackernews clone. Create the frontend with create-react-app and the backend with Prisma."
						},
						"fields": {
							"slug": "/react-apollo/1-getting-started/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Summary",
							"description": "In this Fullstack GraphQL Tutorial with React & Apollo Client you learned how to build a production-ready Hackernews clone using create-react-app & Prisma."
						},
						"fields": {
							"slug": "/react-apollo/10-summary/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Mutations: Creating Links",
							"description": "Learn how you can use GraphQL mutations with Apollo Client. Use Apollo's `<Mutation />` component to define and send mutations."
						},
						"fields": {
							"slug": "/react-apollo/3-mutations-creating-links/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Queries: Loading Links",
							"description": "Learn how you can use GraphQL queries with Apollo Client to load data from a server and display it in your React components."
						},
						"fields": {
							"slug": "/react-apollo/2-queries-loading-links/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Routing",
							"description": "Learn how to use react-router 4 together with GraphQL and Apollo Client to implement navigation in a React app. Each route will be represented as a `Link`."
						},
						"fields": {
							"slug": "/react-apollo/4-routing/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Authentication",
							"description": "Learn best practices to implement authentication with GraphQL & Apollo Client to provide an email-and-password-based login in a React app with Prisma."
						},
						"fields": {
							"slug": "/react-apollo/5-authentication/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "More Mutations and Updating the Store",
							"description": "Learn how to use Apollo's imperative store API to update the cache after a GraphQL mutation. The updates will automatically end up in your React components."
						},
						"fields": {
							"slug": "/react-apollo/6-more-mutations-and-updating-the-store/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Filtering: Searching the List of Links",
							"description": "Learn how to use filters with GraphQL and Apollo Client. Prisma provides a powerful filter and ordering API that you'll explore in this example."
						},
						"fields": {
							"slug": "/react-apollo/7-filtering-searching-the-list-of-links/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Realtime Updates with GraphQL Subscriptions",
							"description": "Learn how to implement realtime functionality using GraphQL subscriptions with Apollo Client & React. The websockets will be handled by subscriptions-transport-ws."
						},
						"fields": {
							"slug": "/react-apollo/8-subscriptions/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Pagination",
							"description": "Learn how to implement limit-offset pagination with GraphQL and Apollo Client in a React app. The Prisma API exposes the required arguments for lists."
						},
						"fields": {
							"slug": "/react-apollo/9-pagination/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Introduction",
							"description": "Learn how to build a production-ready Hackernews clone with GraphQL, React & Relay. You'll use create-react-app for the frontend and Graphcool for the backend."
						},
						"fields": {
							"slug": "/react-relay/0-introduction/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Getting Started",
							"description": "Start building a Hackernews clone. Create the frontend with create-react-app and the backend with Graphcool."
						},
						"fields": {
							"slug": "/react-relay/1-getting-started/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Queries: Loading Links",
							"description": "Learn how you can use GraphQL Fragments and Relay's QueryRenderer to load data from a server and display it in your React components."
						},
						"fields": {
							"slug": "/react-relay/2-queries-loading-links/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Mutations: Creating Links",
							"description": "Learn how to use Relay Modern's new Mutation API to send mutations to a GraphQL server. With Relay Modern you can also update the cache directly after the mutation."
						},
						"fields": {
							"slug": "/react-relay/3-mutations-creating-links/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Routing",
							"description": null
						},
						"fields": {
							"slug": "/react-relay/4-routing/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Authentication",
							"description": "Learn best practices to implement authentication with GraphQL & Relay to provide an email-and-password-based login in a React app with Graphcool."
						},
						"fields": {
							"slug": "/react-relay/5-authentication/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Realtime Updates with Subscriptions",
							"description": "Learn how to implement realtime functionality using GraphQL subscriptions with Relay Modern & React. The websockets will be handled by subscriptions-transport-ws."
						},
						"fields": {
							"slug": "/react-relay/7-subscriptions/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "More Mutations and Updating the Store",
							"description": "Learn how to use Relay Modern's imperative API to update the cache after a GraphQL mutation. The updates will automatically end up in your React components."
						},
						"fields": {
							"slug": "/react-relay/6-more-mutations-and-updating-the-store/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Pagination",
							"description": "Learn how to implement cursor-based pagination with GraphQL and Relay Modern using `PaginationContainer`. Relay uses the concept of connections to represent lists."
						},
						"fields": {
							"slug": "/react-relay/8-pagination/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Summary",
							"description": "In this Fullstack GraphQL Tutorial with React & Relay Modern you learned how to build a production-ready Hackernews clone using create-react-app & Graphcool."
						},
						"fields": {
							"slug": "/react-relay/9-summary/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Clients",
							"description": "Learn about GraphQL clients, like Relay and Apollo Client, and the features they provide, such as caching, schema validation and query/view colocation."
						},
						"fields": {
							"slug": "/advanced/0-clients/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "More GraphQL Concepts",
							"description": "Learn about advanced concepts of the GraphQL language like fragments, query arguments, aliases, interfaces and more SDL features"
						},
						"fields": {
							"slug": "/advanced/2-more-graphql-concepts/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Server",
							"description": "Learn about the major concepts of GraphQL servers, how it executes GraphQL queries with resolver functions and batches multiple requests."
						},
						"fields": {
							"slug": "/advanced/1-server/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Tooling and Ecosystem",
							"description": "Learn about the GraphQL ecosystem and its awesome tooling like the GraphiQL playgrounds or self-generating docs through introspection."
						},
						"fields": {
							"slug": "/advanced/3-tooling-and-ecosystem/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Security",
							"description": "Learn about different security aspects and strategies for GraphQL, such as timeouts, maximum query depth, query complexity and throttling."
						},
						"fields": {
							"slug": "/advanced/4-security/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Common Questions",
							"description": "Answer common GraphQL questions about server-side caching, authentication, authorization, error handling, offline usage and more."
						},
						"fields": {
							"slug": "/advanced/5-common-questions/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Introduction",
							"description": "Learn how to build a Hackernews clone with GraphQL, VueJS & Apollo Client. You'll use vue-cli for the frontend and Graphcool for the backend."
						},
						"fields": {
							"slug": "/vue-apollo/0-introduction/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Queries: Loading Links",
							"description": "Learn how you can use GraphQL queries with Apollo Client to load data from a server and display it in your VueJS components."
						},
						"fields": {
							"slug": "/vue-apollo/2-queries-loading-links/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Summary",
							"description": "In this Fullstack GraphQL Tutorial with VueJS & Apollo Client you learned how to build a production-ready Hackernews clone using vue-cli & Graphcool."
						},
						"fields": {
							"slug": "/vue-apollo/11-summary/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Mutations: Creating Links",
							"description": "Learn how you can use GraphQL mutations with Apollo Client. Use Apollo's `mutate` method to define and send mutations."
						},
						"fields": {
							"slug": "/vue-apollo/3-mutations-creating-links/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Routing",
							"description": "Learn how to use vue-router together with GraphQL and Apollo Client to implement navigation in a VueJS app."
						},
						"fields": {
							"slug": "/vue-apollo/4-routing/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Getting Started",
							"description": "Start building a Hackernews clone. Create the frontend with vue-cli and the backend with Graphcool."
						},
						"fields": {
							"slug": "/vue-apollo/1-getting-started/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Deploying",
							"description": "Learn how to deploy an application built with VueJS and Graphcool through Surge.sh."
						},
						"fields": {
							"slug": "/vue-apollo/10-deploying/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Authentication",
							"description": "Learn best practices to implement authentication with GraphQL & Apollo Client to provide an email-and-password-based login in a VueJS app with Graphcool."
						},
						"fields": {
							"slug": "/vue-apollo/5-authentication/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "More Mutations and Updating the Store",
							"description": "Learn how to use Apollo's imperative store API to update the cache after a GraphQL mutation. The updates will automatically end up in your VueJS components."
						},
						"fields": {
							"slug": "/vue-apollo/6-more-mutations-and-updating-the-store/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Filtering: Searching the List of Links",
							"description": "Learn how to use filters with GraphQL and Apollo Client. Graphcool provides a powerful filter and ordering API that you'll explore in this example."
						},
						"fields": {
							"slug": "/vue-apollo/7-filtering-searching-the-list-of-links/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Realtime Updates with GraphQL Subscriptions",
							"description": "Learn how to implement realtime functionality using GraphQL subscriptions with Apollo Client & VueJS. The websockets will be handled by subscriptions-transport-ws."
						},
						"fields": {
							"slug": "/vue-apollo/8-subscriptions/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Introduction",
							"description": "Learn all about GraphQL and why it is an API technology that's superior to REST. It is not only for React & Javascript developers but can be used for any API."
						},
						"fields": {
							"slug": "/basics/0-introduction/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "GraphQL is the better REST",
							"description": "Learn why GraphQL is a more efficient and flexible alternative to REST APIs. It has a strong type system and avoids frontend issues like over- and underfetching."
						},
						"fields": {
							"slug": "/basics/1-graphql-is-the-better-rest/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Core Concepts",
							"description": "Learn about the basic GraphQL language concepts, such as Queries, Mutations, Subscriptions and the GraphQL Schema & SDL. Try them out in your own sandbox."
						},
						"fields": {
							"slug": "/basics/2-core-concepts/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Introduction",
							"description": "Learn how to build a Hackernews clone with GraphQL, Ember, and Apollo Client. You'll use Ember and ember-apollo-client for the frontend and Graphcool for the backend."
						},
						"fields": {
							"slug": "/ember-apollo/0-introduction/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Big Picture (Architecture)",
							"description": "Learn about different architectural use cases of GraphQL and the major components on the backend and the frontend, like resolver functions and client libraries."
						},
						"fields": {
							"slug": "/basics/3-big-picture/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Getting Started",
							"description": "Start building a Hackernews clone. Create the frontend with ember-cli, ember-apollo-client, and the backend with Graphcool."
						},
						"fields": {
							"slug": "/ember-apollo/1-getting-started/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Queries: Loading Links",
							"description": "Learn how you can use GraphQL queries with Apollo Client to load data from a server and display it in your React components."
						},
						"fields": {
							"slug": "/ember-apollo/2-queries-loading-links/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Navigation",
							"description": "Learn how to use Ember components together with GraphQL and Apollo Client to implement navigation in an Ember app."
						},
						"fields": {
							"slug": "/ember-apollo/4-navigation/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Mutations: Creating Links",
							"description": "Learn how you can use GraphQL mutations with Apollo Client. Use `ember-apollo-client` to send mutations."
						},
						"fields": {
							"slug": "/ember-apollo/3-mutations-creating-links/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "More Mutations and Updating the Store",
							"description": "Learn how to use Apollo's imperative store API to update the cache after a GraphQL mutation. The updates will automatically end up in your Ember app."
						},
						"fields": {
							"slug": "/ember-apollo/6-more-mutations-and-updating-the-store/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Filtering: Searching the List of Links",
							"description": "Learn how to use filters with GraphQL and Apollo Client. Graphcool provides a powerful filter and ordering API that you'll explore in this example."
						},
						"fields": {
							"slug": "/ember-apollo/7-filtering-searching-the-list-of-links/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Summary",
							"description": "In this Fullstack GraphQL Tutorial with Ember & Apollo Client you learned how to build a production-ready Hackernews clone using ember-apollo-client & Graphcool."
						},
						"fields": {
							"slug": "/ember-apollo/8-summary/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Pagination",
							"description": "Learn how to implement limit-offset pagination with GraphQL and Apollo Client in a VueJS app. The Graphcool API exposes the required arguments for lists."
						},
						"fields": {
							"slug": "/vue-apollo/9-pagination/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Authentication",
							"description": "Learn best practices to implement authentication with GraphQL & Apollo Client to provide an email-and-password-based login in an Ember app with Graphcool."
						},
						"fields": {
							"slug": "/ember-apollo/5-authentication/"
						}
					}
				}
			]
		}
	},
	"pathContext": {
		"slug": "/graphql-js/0-introduction/"
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/graphql-js-0-introduction.json
// module id = ./node_modules/json-loader/index.js!./.cache/json/graphql-js-0-introduction.json
// module chunks = 100